import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { routes, PrivateRoute, PublicRoute } from "./routes";
import "./App.css";
import { ApolloProvider } from "@apollo/client";
import { client } from "./services/client";
import UserService from "./utils/userService";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFileCircleCheck,
  faTableColumns,
  faWarehouse,
  faChartSimple,
  faHouse,
  faTablet,
  faTv,
  faSdCard,
  faChevronDown,
  faChevronUp,
  faQrcode,
  faTruckFast,
  faTriangleExclamation,
  faUpload,
  faCertificate,
  faLinkSlash,
  faCircleCheck,
  faClose,
  faCirclePlus,
  faTrash,
  faChevronLeft,
  faChevronRight,
  faFileVideo,
  faPhotoFilm,
  faFilePdf,
  faPaperclip,
  faFileImage,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { APIProvider } from "@vis.gl/react-google-maps";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, setUserId } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYnx4ryNJx-XAkjg4O95T2tvQ4F56ygCI",
  authDomain: "greenfield-9a59d.firebaseapp.com",
  projectId: "greenfield-9a59d",
  storageBucket: "greenfield-9a59d.appspot.com",
  messagingSenderId: "103768459459",
  appId: "1:103768459459:web:db713eed6064a414a67a76",
  measurementId: "G-VNVMZ3KDW6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
setUserId(
  analytics,
  UserService.getUserData()?.email || UserService.getUserData()?.id
);

const isAuthenticated = UserService.isLoggedIn();

function App() {
  library.add(
    faFileCircleCheck,
    faTableColumns,
    faWarehouse,
    faChartSimple,
    faHouse,
    faTablet,
    faTv,
    faSdCard,
    faChevronDown,
    faChevronUp,
    faQrcode,
    faTruckFast,
    faTriangleExclamation,
    faUpload,
    faCertificate,
    faLinkSlash,
    faCircleCheck,
    faClose,
    faTrash,
    faCirclePlus,
    faChevronLeft,
    faChevronRight,
    faFileImage,
    faFileVideo,
    faPhotoFilm,
    faFilePdf,
    faPaperclip,
    faSpinner
  );

  return (
  <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} onLoad={() => console.log('Maps API has loaded.')}>
    <ApolloProvider client={client}>
      <HashRouter>
        <Routes>
          {routes.map(({ path, component: Component, privateRoute, openRoute }) => (
            <Route
              key={path}
              path={path}
              element={
                openRoute ? (
                  <Component />
                ) : privateRoute ? (
                  <PrivateRoute
                    component={Component}
                    isAuthenticated={isAuthenticated}
                  />
                ) : (
                  <PublicRoute
                    component={Component}
                    isAuthenticated={isAuthenticated}
                  />
                )
              }
            />
          ))}
        </Routes>
      </HashRouter>
    </ApolloProvider>
    </APIProvider>
  );
}
export const auth = getAuth(app);
export default App;
